export enum BankingPageViewEnum {
  Banking = 0,
  PadScheduleHistory = 1,
  PadHistory = 2,
}
